package com.wintermar.inspection.core.ui.widget

import androidx.compose.animation.animateContentSize
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.tween
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import com.wintermar.inspection.core.ui.component.TextBodyTiny
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import kotlin.math.floor

@Composable
fun CircularProgress(
    progress: Int,
    total: Int,
    modifier: Modifier = Modifier,
    size: Dp = LocalAppTheme.current.dimension.spacing.space9,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    color: ThemeColor = LocalAppTheme.current.color
) {
    val totalCount by remember(total) {
        derivedStateOf { total }
    }

    val targetProgress by remember(totalCount, progress) {
        derivedStateOf {
            val progressValue = (if (progress > totalCount) totalCount else progress).toFloat()
            if (totalCount == 0) 0f else progressValue / totalCount
        }
    }

    val animatedProgress by animateFloatAsState(
        targetValue = targetProgress,
        animationSpec = tween(durationMillis = 450)
    )

    val answeredPercent = floor(animatedProgress * 100).toInt()

    Row(
        modifier = Modifier,
        horizontalArrangement = Arrangement.spacedBy(dimension.spacing.space2),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(
            modifier = Modifier.background(
                color = color.surface.normal,
                shape = RoundedCornerShape(dimension.radius.full)
            ),
            contentAlignment = Alignment.Center
        ) {
            CircularProgressIndicator(
                progress = { animatedProgress },
                modifier = modifier
                    .size(size)
                    .animateContentSize(),
                trackColor = color.surface.neutral.subtle.default,
                strokeWidth = dimension.spacing.space1,
                gapSize = dimension.spacing.space0,
            )

            TextBodyTiny(
                text = "$answeredPercent%",
                color = { it.subtle },
                modifier = Modifier.animateContentSize()
            )
        }
    }
}
